import React, { useState, lazy, Suspense, useEffect } from "react";
import axios from "axios";
import CacheBuster from "react-cache-buster";
import appversion from "../package.json";

// import Header from './components/Header';
//import CallMeForm from './components/CallMeForm';

// import Footer from './components/Footer';
// import PressKit from "./components/PressKit";
// import Powered from "./components/powered";
// import Empathetic from "./components/Empathetic";

import Logo from "./components/Logo Section/Logo";

import "@fontsource/poppins";

import "./App.css";

const Header = lazy(() => import("./components/Header.js"));
// const Story = lazy(() => import("./components/Stroy.js"));
const Highlight = lazy(() => import("./components/Highlights.js"));
const Empathetic = lazy(() => import("./components/Empathetic.js"));
const Powered = lazy(() => import("./components/powered.js"));
const PressKit = lazy(() => import("./components/PressKit.js"));
const Footer = lazy(() => import("./components/Footer.js"));

function App() {
  const appVersion = appversion.version;
  useEffect(() => {
    const script = document.createElement("script");

    script.type = "text/javascript";
    script.src = process.env.REACT_APP_SWMC_ANALYTICS;
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const [links, setLinks] = useState([]);
  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_ANGELAI_JSON);
        setLinks(response.data.current);
      } catch (error) {
        console.error("Error fetching links:", error);
      }
    };
    fetchLinks();
  }, []);
  return (
    <CacheBuster
      currentVersion={appVersion}
      isEnabled={true} //If false, the library is disabled.
      isVerboseMode={false} //If true, the library writes verbose logs to console.
      metaFileDirectory={"."} //If public assets are hosted somewhere other than root on your server.
    >
      <>
    
        <Suspense fallback={<div />}>
          <Header links={links} />
        </Suspense>
        {/* <Suspense fallback={<div />}> 
        <Story />
      </Suspense> */}
        <Suspense fallback={<div />}>
          <Highlight links={links} />
        </Suspense>
        <Suspense fallback={<div />}>
          <Empathetic links={links} />
        </Suspense>
        <Suspense fallback={<div />}>
          <Powered links={links} />
        </Suspense>
        <Suspense fallback={<div />}>
          <PressKit links={links} />
        </Suspense>
        <Suspense fallback={<div />}>
          <Footer />
        </Suspense>
        
      </>
    </CacheBuster>
  );
}

export default App;
